import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import MarqueeBand from "../components/MarqueeBand";

const CHAPTERS = [
  {
    n: "01",
    title: "Why analog",
    body: "Your phone does everything, which is why nothing on it feels like anything. A cassette only plays. A flip phone only calls. An instant photo can't be edited. Constraints aren't a bug — they're the entire feature. Stay Retro exists because a generation raised on infinite scroll is choosing objects with edges.",
  },
  {
    n: "02",
    title: "How curation works",
    body: "We dig through resale listings, collector forums and auction data to find the pieces worth your money — working condition, fair price, real nostalgia. Then we write the lore: why it died, why it came back, and the one stat that tells the story.",
  },
  {
    n: "03",
    title: "The deal",
    body: "We hold no inventory, run no warehouse, and there is no checkout on this site. Every Buy button takes you to an external retailer — eBay, Etsy, Amazon — and we may earn an affiliate commission on qualifying purchases. It never changes the price you pay. That's the whole business model, in the open.",
  },
  {
    n: "04",
    title: "The rules",
    body: "No fake scarcity timers. No cart abandonment emails. No accounts, no cookies banners fighting you, no algorithmic feeds. You click, you buy from a retailer you already know, you go outside. Touch grass, press buttons.",
  },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b-2 border-charcoal bg-mint py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <p className="font-mono text-xs font-bold uppercase tracking-wide text-charcoal/70">The manifesto</p>
            <h1 className="mt-2 max-w-4xl font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              The future is a physical object
            </h1>
            <p className="mt-6 max-w-xl text-base md:text-lg text-charcoal/80">
              Stay Retro is a curated storefront for 90s and early-2000s analog tech.
              Not a museum. Not a shop. A filter between you and the entire resale internet.
            </p>
          </Reveal>
        </div>
      </section>

      <MarqueeBand bg="bg-coral" text="text-white" words={["NOT A SHOP", "NO INVENTORY", "NO CHECKOUT", "JUST THE GOOD STUFF", "LINKED, NOT SOLD"]} />

      <section className="bg-cream py-16 lg:py-24">
        <div className="mx-auto max-w-5xl px-4 sm:px-6">
          <div className="flex flex-col gap-12">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <article data-testid={`about-chapter-${c.n}`} className="grid gap-4 border-t-2 border-charcoal pt-8 md:grid-cols-12">
                  <span className="font-mono text-sm font-bold text-blue md:col-span-2">CH.{c.n}</span>
                  <div className="md:col-span-10">
                    <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">{c.title}</h2>
                    <p className="mt-3 max-w-2xl text-base leading-relaxed text-charcoal/80 md:text-lg">{c.body}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-16">
            <div className="card-chunky flex flex-col items-start justify-between gap-6 bg-blue p-8 text-white sm:flex-row sm:items-center">
              <div>
                <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">Ready to unplug?</h2>
                <p className="mt-2 text-white/85">Twelve pieces. Four starter packs. Zero infinite scroll.</p>
              </div>
              <Link to="/shop" data-testid="about-cta-shop" className="btn-chunky bg-yellow px-8 py-4 text-lg text-charcoal hover:bg-cream">
                Shop the 90s <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
